import styled from '@emotion/styled';
import { Trans, useLingui } from '@lingui/react/macro';
import { Settings } from 'lucide-react';
import React from 'react';
import { theme } from 'styles/theme/theme';
import { getStageTypeLabel } from 'modules/championship/domain/constants/stage-type-labels';
import { StageType } from 'modules/championship/domain/enums/stage-type';
import { StageV2 } from 'modules/championship/domain/interfaces/stage';

const StyledStageCardContainer = styled.div`
  background: ${({ theme }) => theme.colors.SurfaceWhite};
  border-radius: 8px;
  min-height: 157px;
`;

const StyledStageCardHeader = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.SurfacePlatinum20};
  padding: 16px 16px 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const StyledStageCardHeaderSettings = styled.div`
  display: flex;
  align-items: center;
`;

const StyledStageCardBody = styled.div`
  padding: 12px 16px;
`;

const StyledStageCardProperty = styled.div`
  display: inline-block;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 16px;
  margin: 10px 24px 10px 0;

  .label {
    color: ${({ theme }) => theme.colors.SurfaceRomanSilver30};
    margin-right: 10px;
  }

  .value {
    background: ${({ theme }) => theme.colors.SurfaceCultured10};
    border-radius: 8px;
    color: ${({ theme }) => theme.colors.SurfaceRaisinBlack50};
    padding: 4px 8px;
  }
`;

type StageCardProps = {
  stage: StageV2;
  onSelect?: () => void;
};

const StageCard = ({ stage, onSelect }: StageCardProps) => {
  const { t } = useLingui();
  const stageTypeLabel = getStageTypeLabel(stage.type);

  return (
    <StyledStageCardContainer>
      <StyledStageCardHeader onClick={onSelect}>
        <div className="text callout">{stage.name}</div>
        <StyledStageCardHeaderSettings>
          <Settings size={18} color={theme.colors.SurfaceRomanSilver30} />
          <span className="text subhead ml-2">
            <Trans>Настройки</Trans>
          </span>
        </StyledStageCardHeaderSettings>
      </StyledStageCardHeader>
      <StyledStageCardBody>
        <StyledStageCardProperty>
          <span className="label">
            <Trans>Тип этапа</Trans>
          </span>
          <span className="value">{stageTypeLabel ? t(stageTypeLabel) : stage.type}</span>
        </StyledStageCardProperty>
        <StyledStageCardProperty>
          <span className="label">
            <Trans>Игра за место</Trans>
          </span>
          <span className="value">1</span>
        </StyledStageCardProperty>
        <StyledStageCardProperty>
          <span className="label">
            <Trans context="teams count">Команд</Trans>
          </span>
          <span className="value">{stage.teams.length}</span>
        </StyledStageCardProperty>
        <StyledStageCardProperty>
          <span className="label">
            <Trans>Размер сетки</Trans>
          </span>
          {stage.type === StageType.SINGLE_ELIMINATION ? (
            <span className="value">{stage.brackets.length}</span>
          ) : (
            <span className="value">
              <Trans>Исходя из списка команд</Trans>
            </span>
          )}
        </StyledStageCardProperty>
      </StyledStageCardBody>
    </StyledStageCardContainer>
  );
};

export default StageCard;
